import React, { useContext, useEffect } from 'react';
import { AppContext } from 'Context';
import { SettingsPage } from '../private/settings/components/page';
import MembershipDemo from './MembershipDemo';

// Settings → Affiliate Program (Beta). Hosts the membership enrollment demo.
export const AffiliateSettings = () => {
  const { setLineReq } = useContext(AppContext);

  // Hide the SettingsPage title divider — this page has no page title.
  useEffect(() => {
    if (setLineReq) setLineReq(true);
    return () => { if (setLineReq) setLineReq(false); };
  }, [setLineReq]);

  return (
    <SettingsPage>
      <MembershipDemo />
    </SettingsPage>
  );
};

export default AffiliateSettings;
